import enviro from 'enviro';
import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import PortalIdParser from 'PortalIdParser';
import { Flow } from 'signup-constants/Flow';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';

const isQa = () => enviro.isQa();

export const getDownloadedAssetsUrl = (isPublic = false) => {
  if (isPublic) {
    return `${getFullUrl('app', {
      hubletOverride: na1
    })}/l/marketplace-settings/downloads/theme`;
  }

  return `${getFullUrl('app')}/marketplace-settings/${PortalIdParser.get()}/downloads/theme`;
};
export const getDownloadedAssetsSuccessUrl = params => `${getDownloadedAssetsUrl()}?${stringify(params)}`;
export const getDownloadedAssetsUpdateUrl = offeringId => `${getDownloadedAssetsUrl()}?updateOfferingId=${offeringId}`;
export const getCmsHubPricingUrl = () => 'https://www.hubspot.com/pricing/cms';
export const getMarketingHubPricingUrl = () => 'https://www.hubspot.com/pricing/marketing';

const getCmsFreeSignupQuery = theme => {
  const query = {
    intent: 'marketplaceTheme'
  };

  if (theme) {
    query.theme = theme;
  }

  return query;
};

export const getCmsFreeSignupUrl = theme => {
  return new SignupUrlGenerator(Flow.CmsFree, {
    env: isQa() ? 'qa' : 'prod',
    query: getCmsFreeSignupQuery(theme)
  }).getUrl();
};
export const getCmsFreeLoginSignupParams = theme => {
  return JSON.stringify([Flow.CmsFree, {
    query: getCmsFreeSignupQuery(theme)
  }]);
};
export const getAppShortlink = ({
  pathname = '',
  query = {},
  theme
} = {}, includeSignupParams = true) => {
  const signupParams = getCmsFreeLoginSignupParams(theme);
  const params = stringify(Object.assign({}, query, {
    signupParams: includeSignupParams ? signupParams : undefined
  }));
  return `${getFullUrl('app', {
    hubletOverride: 'na1'
  })}/l/ecosystem/marketplace/website${pathname}${params ? `?${params}` : ''}`;
};